import controller from './collapsable-invoices.controller'
import template   from './collapsable-invoices.html'
import './collapsable-invoices.styl'

let component = {
  restrict: 'E',
  bindings: {
    record: '<',
    orders: '<'
  },
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/collapsable-invoices/collapsable-invoices.component.js